export class AdjustmentListQuery {
    constructor(public AjType?, public ScID?, public Period?, public FromDate?, public ToDate?) { }
}